import { useEffect, useState } from 'react';
import { api } from '../../../lib/api';
import { Video } from '../../../types/videos';

export function useVideoDetail(id: string) {
  const [data, setData] = useState<Video | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await api.get<{ data: Video }>(`/videos/${id}`);
      setData(res.data);
    } catch (e: any) {
      setError(e.message || 'Failed to load');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return { data, loading, error, reload: load };
}
